<footer class="footer fixed-bottom">
  <div
    class="container d-flex align-items-center justify-content-between padding">
    <div class="col-lg-3">
      <a class="text-color" routerLink="competenze"
        ><mat-icon class="margin-competenze">settings</mat-icon
        ><br />Competenze</a
      >
    </div>
    <div class="col-lg-3">
      <a class="text-color" routerLink="consapevolezza"
        ><mat-icon class="margin-consapevolezza">receipt</mat-icon
        ><br />Consapevolezza</a
      >
    </div>
    <div class="col-lg-3">
      <a class="text-color" routerLink="condivisione"
        ><mat-icon class="margin-condivisione">share</mat-icon><br />
        Condivisione</a
      >
    </div>
    <div class="col-lg-3">
      <button mat-icon-button [matMenuTriggerFor]="dropdownMenu">
        <mat-icon class="color-icon-footer">more_horiz</mat-icon></button
      ><br />
      <p class="margin-altro">Altro</p>
      <mat-menu #dropdownMenu="matMenu" yPosition="above">
        <button
          mat-menu-item
          routerLink="percorso-di-crescita"
          routerLinkActive="active-link">
          <mat-icon>timeline</mat-icon>
          Percorso di crescita
        </button>

        <button
          mat-menu-item
          routerLink="i-miei-team"
          routerLinkActive="active-link">
          <mat-icon>diversity_3</mat-icon>
          I miei team
        </button>

        <button
          mat-menu-item
          routerLink="sondaggi"
          routerLinkActive="active-link">
          <mat-icon>article</mat-icon>
          Sondaggi
        </button>

        <button
          mat-menu-item
          routerLink="timesheet"
          routerLinkActive="active-link">
          <div class="d-flex align-items-center">
            <span class="icon material-symbols-outlined me-3">overview</span>
            <p class="mb-0">Time sheet</p>
          </div>
        </button>

        <button mat-menu-item routerLink="wiki" routerLinkActive="active-link">
          <mat-icon>language</mat-icon>
          Wiki
        </button>

        <button
          mat-menu-item
          routerLink="feedback"
          routerLinkActive="active-link">
          <mat-icon>feedback</mat-icon>
          Feedback
        </button>

        <button
          mat-menu-item
          routerLink="impostazioni-admin"
          routerLinkActive="active-link"
          *ngIf="role == 'admin' || role == 'project_manager'">
          <!--  *ngIf="role == 'admin' || role == 'project_manager'"-->
          <mat-icon>admin_panel_settings</mat-icon>
          Impostazioni
        </button>

        <button mat-menu-item routerLink="logout" (click)="logout()">
          <mat-icon>logout</mat-icon>
          Logout
        </button>
      </mat-menu>
    </div>
  </div>
</footer>
